/**
 * Native deep-links shared by the quote surfaces that show contact/estimator details
 * (QuoteDocumentHeader, GatePreviewFooter, …). Kept in one place so every surface dials, mails, and
 * maps identically — these were previously copy-pasted per component.
 */

/** Open a phone number in the native dialer. */
export function openTel(phoneNumber: string) {
  window.open(`tel:${phoneNumber.replaceAll(/\s+/g, '')}`, '_blank')
}

/** Open an email address in the native mail client. */
export function openMailto(email: string) {
  window.open(`mailto:${email}`, '_blank')
}

/** Open an address in Apple Maps on iOS, Google Maps elsewhere (mirrors EditContact). */
export function openMap(address: string) {
  const encodedAddress = encodeURIComponent(address)
  if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
    window.open(`maps://?q=${encodedAddress}`, '_blank')
  } else {
    window.open(`https://www.google.com/maps/search/${encodedAddress}`, '_blank')
  }
}
